import { render, staticRenderFns } from "./RcvED_Receive_Total.vue?vue&type=template&id=3ef0d488"
import script from "./RcvED_Receive_Total.vue?vue&type=script&lang=js"
export * from "./RcvED_Receive_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports